import React from 'react';
import CreatableSelect from 'react-select/lib/Creatable';
import Option from './Option';
import colourStyles from './colourStyles';

export default props => (
  <CreatableSelect {...props} components={{ Option }} styles={colourStyles} />
);
